module.exports = __webpack_public_path__ + "img/hover-iocn48.c520448f.png";